import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Vuetify from 'vuetify'
import VueToastr from '@deveodk/vue-toastr'
import currency from 'v-currency-field'

import router from './router'
import store from './store/'

import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import 'vuetify/dist/vuetify.min.css'
import './registerServiceWorker'
import '@mdi/font/css/materialdesignicons.css'
import 'v-currency-field/dist/index.css'

Vue.use(currency)

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-center',
  defaultType: 'info',
  defaultTimeout: 3000
})

Vue.mixin({
  methods: {
    toastrErrors (errors) {
      let message = ''
      for (var key in errors) {
        let value = errors[key]
        message +=
          key +
          ' ' +
          (value.length ? value.join(', ') : value) +
          '\n'
      }
      if (!this.$toastr) {
        console.error('this.$toastr function is not available.')
        return
      }
      this.$toastr('error', message, 'error')
    }
  }
})

Vue.config.productionTip = false

Vue.use(Vuetify, { iconfont: 'mdi' })
Vue.use(require('vue-moment'));

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
      if (error.response) {
        const response = error.response;
        if (response.status === 401 || response.data.detail === "Authentication credentials were not provided.") {
          store.dispatch('logout').then(() => {
              location.href = '/';
          }).catch(() => {
              location.href = '/';
          });
        } else if (response.status === 503) {
          store.dispatch('logout').then(() => {
              location.href = '/';
          }).catch(() => {
              location.href = '/';
          });
        }
      }
      return Promise.reject(error);
    }
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
